<div class="vawt-tracker" *ngIf="!loading; else loadingTpl">
  <div class="tracker-layout">

    <!-- Sidebar -->
    <aside class="sidebar">
      <div class="project-header">
        <div class="project-title">⚡ Backyard VAWT</div>
        <div class="project-meta">{{ totalCompletedCount() }} of {{ totalTaskCount() }} tasks complete</div>
        <div class="progress-bar-wrap">
          <div class="progress-bar-fill" [style.width.%]="totalProgressPercent()"></div>
        </div>
      </div>

      <div class="phase-label">Phases</div>

      <button
        class="phase-item"
        *ngFor="let phase of phases; let i = index"
        [class.active]="selectedPhaseIndex === i"
        (click)="selectPhase(i)"
      >
        <div class="phase-name">{{ phase.name }}</div>
        <div class="phase-progress-row">
          <div class="phase-mini-bar">
            <div
              class="phase-mini-fill"
              [style.width.%]="phase.tasks.length ? (completedCount(phase) / phase.tasks.length) * 100 : 0"
            ></div>
          </div>
          <span class="phase-count">{{ completedCount(phase) }}/{{ phase.tasks.length }}</span>
        </div>
      </button>
    </aside>

    <!-- Main panel -->
    <main class="main-panel">
      <div class="phase-header">
        <h2>{{ selectedPhase.name }}</h2>
        <p class="phase-desc">{{ selectedPhase.description }}</p>
      </div>

      <div class="section-label">Tasks — {{ completedCount(selectedPhase) }} of {{ selectedPhase.tasks.length }} complete</div>

      <div class="task-list">
        <div
          class="task-item"
          *ngFor="let task of selectedPhase.tasks"
          [ngClass]="taskBorderClass(selectedPhase, task)"
        >
          <input
            type="checkbox"
            [checked]="task.complete"
            (change)="toggleTask(task)"
            [id]="task.id"
          />
          <label [for]="task.id" [class.done]="task.complete">{{ task.label }}</label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Notes -->
      <div class="section-label">Phase Notes</div>

      <div class="notes-list">
        <div class="note-item" *ngFor="let note of selectedPhase.notes">
          <div class="note-date">{{ formatDate(note.timestamp) }}</div>
          <div class="note-text">{{ note.text }}</div>
        </div>

        <div class="note-empty" *ngIf="!selectedPhase.notes?.length">
          No notes yet for this phase.
        </div>
      </div>

      <div class="add-note">
        <textarea
          [(ngModel)]="newNoteText"
          placeholder="Add a note for this phase..."
          rows="3"
        ></textarea>
        <button class="btn-add-note" (click)="addNote()" [disabled]="!newNoteText.trim()">
          Add Note
        </button>
      </div>
    </main>

  </div>
</div>

<ng-template #loadingTpl>
  <div class="loading-wrap">Loading...</div>
</ng-template>
